(() => {
  const loader = document.currentScript;
  const shopify = window.Shopify;
  const project = loader?.dataset.clarityProject;
  const host = loader?.dataset.productionHost;
  const params = new URLSearchParams(window.location.search);
  const preview = ['preview_theme_id', 'preview_key', 'preview_token', 'pb', '_fd'].some((key) => params.has(key));

  if (!project || !host || window.location.protocol !== 'https:' || window.location.port ||
      window.location.hostname !== host || shopify?.theme?.role !== 'main' ||
      shopify.designMode || shopify.visualPreviewMode || preview || window.self !== window.top) return;

  if (window.clarity || document.querySelector('script[src^="https://www.clarity.ms/tag/"]')) return;

  window.clarity = function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  const syncConsent = (marketingAllowed, analyticsAllowed) => {
    window.clarity('consentv2', {
      ad_Storage: marketingAllowed ? 'granted' : 'denied',
      analytics_Storage: analyticsAllowed ? 'granted' : 'denied',
      source: 101
    });
  };

  shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (!error) {
      syncConsent(shopify.customerPrivacy.marketingAllowed(), shopify.customerPrivacy.analyticsProcessingAllowed());
    }
  });

  document.addEventListener('visitorConsentCollected', (event) => {
    syncConsent(event.detail.marketingAllowed, event.detail.analyticsAllowed);
  });

  const tracker = document.createElement('script');
  tracker.async = true;
  tracker.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(project) + '?ref=shopify';
  document.head.appendChild(tracker);
})();
